import script from "./SiteNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteNav.vue?vue&type=script&setup=true&lang=js"

import "./SiteNav.vue?vue&type=style&index=0&id=543fe843&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543fe843"]])

export default __exports__